<template>
  <div>
    <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
          <div class="col">
            <div v-if="successMessage != null">
              <base-alert type="primary" dismissible>
                  <span class="alert-inner--text"> {{successMessage}}</span>
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
              </base-alert>
            </div>
              <div  class="card mb-3">
                  <div class="row no-gutters">
                      <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                        <div class="card-body">
                            <filter-bar @changeFilter="changeFilter"></filter-bar>
                        </div>
                      </div>
                      <div class="col-md-9">
                        <div class="card-header border-0">
                          <div class="row align-items-center">
                            <div class="col-md-12"></div>
                            <div class="col-md-3">
                              <!-- <h3 class="mb-0">
                                Stores
                              </h3> -->
                            </div>
                            <div class="col-md-9 text-right">
                              <base-dropdown
                                class="pr-0 pt-1 float-right"
                                position="right">
                                <div class="media align-items-center" slot="title">
                                  <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                                </div>
                                <template>
                                  <div class="dropdown-header noti-title" >
                                    <h6 class="text-overflow m-0">ACTIONS</h6>
                                  </div>
                                  <div v-if="serverType == 'ho'"
                                    class="dropdown-item"
                                    @click.prevent="showActionDrawer('configuration')"
                                  >
                                    <i class="fa fa-cog"></i>
                                    <span>Configuration</span>
                                  </div>
                                  <div class="dropdown-item" @click.prevent="showActionDrawer('configurationlist')">
                                      <i class="fa fa-history"></i>
                                      <span>Configuration History</span>
                                  </div>
                                </template>
                              </base-dropdown>
                              <a-drawer
                                title=""
                                :width="width"
                                placement="right"
                                @close="onClose"
                                :visible="drawerVisible"
                                v-if="drawerVisible"
                              > 
                                <div v-if="profileAction == 'configurationlist'">
                                    <document-configuration-history @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey">asa</document-configuration-history>
                                </div>

                                <div v-if="profileAction == 'configuration'">
                                  <h6 class="heading-small text-muted">Sales Channel Configuration</h6>
                                  <base-alert v-if="errors.length" type="danger">
                                    <b>You have the following error(s):</b>
                                    <li v-for="error in errors" :key="error">{{ error }}</li>
                                  </base-alert>

                                  <dynamic-form
                                    :convertedJson="convertedJson"
                                    :formSettings="formSettings"
                                    @valueUpdated="updateSettings"
                                  ></dynamic-form>

                                  <div
                                    class="float-right"
                                    style="position: absolute; bottom: 20px; right: 20px"
                                  >
                                    <a-spin :tip="spinMessage" :spinning="spinning">
                                      <button class="btn btn-success" @click.prevent="processSettings">
                                        Save
                                      </button>
                                    </a-spin>
                                  </div>
                                </div>
                              </a-drawer>
                              <a-button type="primary" class="btn float-right ml-1 btn-primary btn-sm" @click.prevent="addSalesChannel"> + Add</a-button>
                              <a-drawer title="" width="100%" placement="right" @close="onClose" :visible="visible" v-if="visible">
                                <div>
                                  <online-store-form @closeDrawer="closeDrawer" :salesChannelId="salesChannelId" v-on:refreshPage="refreshPage" :viewMode="viewMode" :action="action" :formSettings="formSettings"> </online-store-form>
                                </div>
                              </a-drawer>
                            </div>
                          </div>
                        </div>
                        <div class="card-body">
                          <div class="table-responsive pt-2">
                            <div id="sales-channel-table"></div>
                          </div>
                        </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
    import axios from "axios";
    import secureStorage from '../../controllers/secureStorage.js'
    import HTTPRequest from '../../controllers/httpRequest.js'
    import OnlineStoreForm from '../../views/Sales Channel/OnlineStoreForm.vue'
    import FilterBar from './../FilterBar'
    import Tabulator from 'tabulator-tables'
    import moment from 'moment'
    import DynamicForm from "../DynamicForm.vue"
    import DocumentConfigurationHistory from '../Documents/DocumentConfigurationHistory.vue'

    import { mapState, mapActions } from 'vuex'
    var table;
    var component_x;
    var ObjGen = require("../../../node_modules/objgen/objgen.js").ObjGen;
    export default {
    components: {
      FilterBar,
      OnlineStoreForm,
      DynamicForm,
      DocumentConfigurationHistory
    },
    computed: {
      ...mapState(['endPoint', 'parameters','serverType'])
    },
    data() {
      return {
        viewMode: false,
        action:null,
        salesChannelId:null,
        visible:false,
        data:[],
        statusFilter:0,
        searchFilter:'name',
        searchText:'',
        successMessage:null,
        profileAction: "",
        isAdmin: false,
        width: 500,
        formSettings: { isAdmin: false },
        componentKey: 0,
        drawerVisible:false,
        errors:[],
        convertedJson: null,
        spinMessage: 'Saving......',
        spinning : false,
        initialSettings: {},
        settingsValue:{},
        options: {
          layout:"fitDataStretch",
          ajaxURL:'',
          ajaxConfig:{
            method:"GET", 
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
          },
          pagination:"remote",
          paginationDataSent:{
            "page":"page",
            "size":"per_page"
          },
          showData:[],
          paginationSize:10,
          columns:[
            {title: 'Name', field: "name", formatter: this.addLink,cellClick: this.selectProductName, align:'center', headerSort:false},
            {title: 'Type', field: "sales_channel_type", formatter: this.salesChannelType, width:200, headerSort:false},
            {title: 'Status', field: 'status', headerSort:false},
            {title: 'Action',align:'center',formatter: this.addButton,cellClick: this.selectProductAction,headerSort: false},
          ],
        },
      }
    },
    mounted: async function(){
      component_x = this;
      this.allData()
      // var c = this.getQueryParams(window.location.hash)
      var c = this.$route.query
      if (c["marketplace"]!=undefined || c["shop"]!=undefined){
        this.action = "resume_create"
        this.showDrawer()
      }
      await this.parseConfiguration()
    },
    methods:{
      changeFilter: function(statusFilter, searchFilter, searchText){
        this.statusFilter = statusFilter
        this.searchFilter = searchFilter
        this.searchText = searchText
        this.allData()
      },
      showDrawer() {
        this.visible = true;
      },
      onClose() {
        this.visible = false;
        this.drawerVisible = false;
        this.salesChannelId = null;
        this.componentKey++;
      },
      closeDrawer(){
        this.onClose()
      },
      refreshPage() {
        this.allData()
        this.successMessage = "Successful Operation"
        this.onClose()
      },
      allData: async function(){
        this.options.ajaxURL = this.endPoint + 'sales_channels?statusFilter='+this.statusFilter+'&searchFilter='+this.searchFilter+'&searchText='+this.searchText
        table = new Tabulator("#sales-channel-table", this.options);
      },
      addLink (cell, formatterParams){
        let name = cell.getRow().getData().name
        let id = cell.getRow().getData().id 
        var link
        if(cell.getRow().getData().sales_channel_type == "online_store"){
          link = '<a id="'+id+'" style="cursor: pointer;color: #5e72e4;" class="font-weight-bold">'+name+'</a>'
        }else{
          link = name
        }
        return link
      },
      addButton (cell, formatterParams){
        let id = cell.getRow().getData().id
        var button = ""
        button += '<button id="' + id + '" name="View" class="btn btn-success btn-sm">View</button>'
        button += '<button id="' + id + '" name="Edit" class="btn btn-sm btn-warning">Edit</button>'
        button += '<button id="' + id + '" name="Delete" class="btn btn-sm btn-danger">Delete</button>'
        return button
      },
      addSalesChannel: function(){
        this.action = "Create"
        this.showDrawer()
      },
      selectProductAction: function(e, cell){
        if(e.target.id!=""){
          switch (e.target.name) {
            case "View":
              this.action = "View";
              this.salesChannelId = e.target.id;
              this.showDrawer()
            break;
            case "Edit":
              this.action = "Edit";
              this.salesChannelId = e.target.id;
              this.showDrawer()
            break;
            case "Delete":
              this.deleteData(e.target.id)
            break;
            default:
            break;
          }
        }
      },
      deleteData: async function(id){
        axios({
          method: 'delete',
          url: this.endPoint + 'sales_channels/' + id,
          headers: {
            Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
            "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"
          },
        })
        .then(function () {
          component_x.successMessage = "Successfully deleted record"
          component_x.refreshPage()
        })
      },
      selectProductName(e, cell){
        var hostname = window.location.hostname
        var port = '';
        if(window.location.port!=null){
          port = ":"+window.location.port
        }
        if (hostname.search(".bxi.world")>=0){
          var href = window.location.protocol+"//"+window.location.hostname+""+port+"/os"+cell.getRow().getData().id
          window.open(href, '_blank');
        }else{
          var href = window.location.protocol+"//"+window.location.hostname+""+port+"/os"+cell.getRow().getData().id
          window.open(href, '_blank');
        }
      },
      salesChannelType(cell, formatterParams){
        let salesChannel = cell.getRow().getData().sales_channel_type
        var text = ""
        switch (salesChannel) {
          case 'online_store':
            text = "Online Store"
          break;
          case 'shopify':
            text = "Shopify"
          break;
          case 'shopee':
            text = "Shopee"
          break;
          case 'lazada':
            text = "Lazada"
          break;
          default:
          break;
        }
        return text
      },
      getQueryParams(qs) {
        var vars = {};
        var parts = qs.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            vars[key] = value;
        });
        return vars;
      },
      async showActionDrawer(action) {
        if (action == "configuration") {
          this.width = 500;
          var userId = secureStorage.getItem("userId");
          var userGroupIds = await HTTPRequest.getRequest(
            this.endPoint + "users/show_user_memberships/?user_id=" + userId,
            null
          );
          var adminGroup = await HTTPRequest.getRequest(
            this.endPoint + "user_groups/Admin?field_name=name",
            null
          );
          if (userGroupIds.user_membership_ids.includes(adminGroup.id)) {
            this.isAdmin = true;
            this.formSettings.isAdmin = this.isAdmin;
          }
        }else if(action == "configurationlist") {
            this.configHistoryVisible = true
            this.width = 1100;
        }  else {
          this.width = 500;
        }

        this.profileAction = action;
        this.drawerVisible = true;
      },
      updateSettings(NewFormSettings) {
        this.formSettings = NewFormSettings;
      },
      async parseConfiguration(){
        var jsonField;
        jsonField = await HTTPRequest.getRequest(
          this.endPoint + "dynamic_forms/SCConfiguration?field_name=profile_name",
          null,
          null
        );
        this.convertedJson = ObjGen.xJson(jsonField.template, { numSpaces: 2 });
        secureStorage.setItem("documentTypeId", -3);
        this.site_id = secureStorage.getItem("defaultSiteId");
        let site = await HTTPRequest.getRequest(
          this.endPoint + "/sites/" + this.site_id,
          null
        );
        if (site != undefined) {
          this.site_type = site.site_type;
        }

        var userId = secureStorage.getItem("userId");
        var response;

        response = await HTTPRequest.getRequest(
          this.endPoint + "/user_settings?module_name=sc&user_id=" + userId,
          null
        );
        var userSettings;
        if (response.data[0] != undefined) {
          userSettings = JSON.parse(response.data[0].settings_json);
        } else {
          userSettings = {};
        }

        response = await HTTPRequest.getRequest(
          this.endPoint + "/system_settings?module_name=sc",
          null
        );
        var systemSettings;
        if (response.data[0] != undefined) {
          systemSettings = JSON.parse(response.data[0].settings_json);
        } else {
          systemSettings = {};
        }

        var mergedHash = Object.assign({}, systemSettings, userSettings);
        this.formSettings = mergedHash;
        var defaultValues = []
        Object.keys(mergedHash).forEach(function (key) { defaultValues.push(key)});
        for (var i = 0; i < defaultValues.length; i++) {
          this.initialSettings[defaultValues[i]] = this.formSettings[defaultValues[i]]
        }
      },
      async processSettings() {
        if (this.formSettings["is_enable_allocation_validation"] == true && this.formSettings["is_enable_allocation_validation"] != this.initialSettings["is_enable_allocation_validation"]){
          this.$confirm({
            title: 'Warning',
            content: h => <div>It will Override all the sales channel Inventory Percentage per sublocation. do you want to continue ?</div>,
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => {
              this.saveSettings()
            },
            onCancel() {
            }
          });
        }else{
          this.saveSettings()
        }
      },
      async saveSettings(){
        this.spinning = true
        var formSettings = this.formSettings;
        var initialSettings = this.initialSettings
        var endPoint = this.endPoint
        Object.keys(formSettings).forEach(function (key) {
          var value = formSettings[key];
          if (value != initialSettings[key]) {
            var configHistoryPayload = {
              config: "",
              config_type: key,
              config_from: initialSettings[key],
              config_to: value,
              config_at: moment(new Date()),
              config_by: secureStorage.getItem("userName"),
              config_account: secureStorage.getItem("accountId"),
              document_type: -3
            }
            // Save config changes
            HTTPRequest.postRequest(endPoint + 'document_configuration_histories/', null, configHistoryPayload)
            initialSettings[key] = value;
          }
        });
        this.initialSettings = initialSettings
        var userId = secureStorage.getItem("userId");
        var response;
        response = await HTTPRequest.getRequest(
          this.endPoint + "/user_settings?module_name=sc&user_id=" + userId,
          null
        );
        if (response.data.length == 0) {
          var createParams = {
            user_setting: {
              module_name: "sc",
              user_id: userId,
              settings_json: JSON.stringify(formSettings),
            },
          };
          await HTTPRequest.postRequest(
            this.endPoint + "/user_settings",
            null,
            createParams
          );
        } else {
          var updateParams = {
            user_setting: {
              module_name: "sc",
              user_id: userId,
              settings_json: JSON.stringify(formSettings),
            },
          };
          await HTTPRequest.putRequest(
            this.endPoint + "/user_settings/" + response.data[0].id,
            null,
            updateParams
          );
        }
        response = await HTTPRequest.getRequest(
          this.endPoint + "/system_settings?module_name=sc",
          null
        );
        if (response.data.length == 0){
          var createParams = {
            module_name: "sc",
            user_id: userId,
            settings_json: JSON.stringify(formSettings),
          };
          await HTTPRequest.postRequest(
            this.endPoint + "/system_settings",
            null,
            createParams
          );
        }else{
          var updateParams = {
            system_setting: {
            module_name: "sc",
            settings_json: JSON.stringify(formSettings),
            },
          };
          await HTTPRequest.putRequest(
              this.endPoint + "/system_settings/" + response.data[0].id,
              null,
              updateParams
          );
        }
        
        if(this.formSettings.is_enable_allocation_validation == true){
          var res = await HTTPRequest.postRequest(this.endPoint + 'sales_channels/change_inventory_percentage_to_all_sales_channel', null)
        }
        alert("Update successful");
        this.closeDrawer();
        this.spinning = false
      }
    }
  }
</script>
<style lang='scss'>
  @import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap";
</style>